import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=49605d00&"
import script from "./LoadingIcon.vue?vue&type=script&lang=js&"
export * from "./LoadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports